import { render } from '@testing-library/react';
import React from 'react'
import '../App.css';
import { BrowserRouter, Route, Switch, withRouter} from 'react-router-dom';

class Slide extends React.Component {
    constructor(){
        super();
        this.state = {
        };
        
    }


    render(){
        return(
            <div className="SlideContainer">
                <img className="SlideImg" src={this.props.type === "png" ? this.props.src : null} style={{display: this.props.type === "png" ? 'block' : 'none' }}/>
                <video controls className="SlideVid" type="video/mp4" src={this.props.type === "mp4" ? this.props.src : null} style={{display: this.props.type === "mp4" ? 'block' : 'none' }}>Sorry Your Browser Doesn't support Embeded Video</video>
                <div className="SlideFooter">
                    <div>{this.props.index + 1}</div>
                    <button id="moveLeft" className={this.props.src} onClick={this.props.move}>Move Left</button>
                    <button id="moveRight" className={this.props.src} onClick={this.props.move}>Move Right</button>
                    <button id={this.props.src} className="trashSlideBtn" onClick={this.props.remove}/>
                </div>
            </div>
        )
    }
}
export default withRouter(Slide);